/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_Download_CvInputs */

const en_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download CV`)
};

const ar_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحميل السيرة الذاتية`)
};

const bn_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সিভি ডাউনলোড`)
};

const de_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf herunterladen`)
};

const es_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar CV`)
};

const fr_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger le CV`)
};

const pt_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixar currículo`)
};

const zh_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载简历`)
};

const tr_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV'yi İndir`)
};

const ru_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать резюме`)
};

const pl_cta_download_cv = /** @type {(inputs: Cta_Download_CvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz CV`)
};

/**
* | output |
* | --- |
* | "Download CV" |
*
* @param {Cta_Download_CvInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_download_cv = /** @type {((inputs?: Cta_Download_CvInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_Download_CvInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_download_cv(inputs)
	if (locale === "bn") return bn_cta_download_cv(inputs)
	if (locale === "de") return de_cta_download_cv(inputs)
	if (locale === "es") return es_cta_download_cv(inputs)
	if (locale === "fr") return fr_cta_download_cv(inputs)
	if (locale === "pt") return pt_cta_download_cv(inputs)
	if (locale === "zh") return zh_cta_download_cv(inputs)
	if (locale === "tr") return tr_cta_download_cv(inputs)
	if (locale === "ru") return ru_cta_download_cv(inputs)
	if (locale === "pl") return pl_cta_download_cv(inputs)
	return en_cta_download_cv(inputs)
});